import React from 'react';
import { Link } from 'react-router-dom';
import './Resources.css';

function Resources() {
  return (
    <div className="resources-hub">
      <div className="resources-hub__inner">
        <h1>Resources</h1>
        <p className="resources-hub__intro">
          Our sheet library and games, plus curated links for gear, electronic chanters, free video
          channels, teachers, tutors, and bands. Full directories live on Learn.
        </p>

        <div className="resources-hub__choices">
          <Link className="resources-hub__card" to="/sheet-share">
            <h2>Sheet music library</h2>
            <p>Browse, share, and practice from our Highland bagpipe sheet music collection.</p>
            <span className="resources-hub__cta">Open sheet library →</span>
          </Link>
          <Link className="resources-hub__card" to="/games">
            <h2>Games</h2>
            <p>Note Blaster, Note Battle, and other pitch games — calibrate first, then play.</p>
            <span className="resources-hub__cta">Open games hub →</span>
          </Link>
          <a className="resources-hub__card" href="/learn/resources.html">
            <h2>Resources hub</h2>
            <p>Overview of all directories plus app shortcuts for tutors and bands.</p>
            <span className="resources-hub__cta">Open Learn resources →</span>
          </a>
          <a className="resources-hub__card" href="/learn/electronic-bagpipes.html">
            <h2>Electronic bagpipes</h2>
            <p>Practice chanters and electronic systems for quiet practice and clean computer input.</p>
            <span className="resources-hub__cta">Browse directory →</span>
          </a>
          <a className="resources-hub__card" href="/learn/bagpipe-gear.html">
            <h2>Gear shops</h2>
            <p>Retailers for pipes, reeds, Highland wear, and band outfitting.</p>
            <span className="resources-hub__cta">Browse shops →</span>
          </a>
          <a className="resources-hub__card" href="/learn/youtube-bagpipe-channels.html">
            <h2>YouTube channels</h2>
            <p>Free instruction channels for technique and tunes between lessons.</p>
            <span className="resources-hub__cta">Browse channels →</span>
          </a>
          <a className="resources-hub__card" href="/learn/recommended-teachers.html">
            <h2>Recommended teachers</h2>
            <p>Jori Chisholm and Matt Willis — teachers we recommend for lessons and curriculum.</p>
            <span className="resources-hub__cta">Read recommendations →</span>
          </a>
          <Link className="resources-hub__card" to="/instruction">
            <h2>Find a tutor</h2>
            <p>Worldwide directory of bagpipe tutors near you.</p>
            <span className="resources-hub__cta">Open tutor finder →</span>
          </Link>
          <Link className="resources-hub__card" to="/bands">
            <h2>Pipe bands</h2>
            <p>Discover local bands or register yours in the directory.</p>
            <span className="resources-hub__cta">Open band finder →</span>
          </Link>
        </div>

        <p className="resources-hub__hint">
          Practice setup?{' '}
          <Link to="/chantersync">Manage Chanters</Link>
          {' · '}
          <Link to="/chanter-test">Chanter Test</Link>
          {' · '}
          <a href="/learn/digital-practice-chanter.html">Electronic vs analog</a>
          {' · '}
          <a href="/learn/calibrate-test-play.html">Calibrate → test → play</a>
        </p>
      </div>
    </div>
  );
}

export default Resources;
